module.exports = __webpack_public_path__ + "static/media/bg.9f5f11e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg.png
// module id = 135
// module chunks = 0